/**
 * Creates an ID of the form 'prefix_timestamp_random' like 'pc_l4g3wlow_16bify7w4r5' where:
 * - The timestamp is base-36 encoded Date.now()
 * - The random portion is an integer between 0 and MAX_SAFE_INTEGER, padded with zeroes.
 *
 * Lexicographic ordering should result in time-based ordering.
 *
 * When used as field names in Firestore, these are considered "simple field names" according to
 * https://firebase.google.com/docs/firestore/quotas
 */
export function generateId<Prefix extends string = 'id'>(prefix: Prefix, now = Date.now()): `${Prefix}_${string}` {
  return (prefix +
    '_' +
    now.toString(36) +
    '_' +
    ('00000000000' + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(36)).slice(-11)) as any;
}
